import React from 'react';
import styles from "../../../styles/applicant/ApplicantTable.module.css";
import { FaSearch } from "react-icons/fa";

const EmptyState = ({ currentConfig, searchQuery, activeFilters }) => {
    return (
        <div className={styles.emptyState}>
            <div className={styles.emptyStateIcon}>
                <FaSearch size={48} />
            </div>
            <h3 className={styles.emptyStateTitle}>{currentConfig.uiText.noResultsTitle}</h3>
            <p className={styles.emptyStateDescription}>
                {currentConfig.uiText.noResultsDescription(searchQuery || activeFilters.length > 0)}
            </p>
        </div>
    );
};

export default EmptyState;